import { useState } from 'react'
import { Popup } from '@/ui'
import { useTranslation } from 'react-i18next'

import { MoreWrapper, MoreButton, CalendarEntry } from './Styles'
import { CalendarEvent } from '..'

type ShowMorePopupProps = {
  formattedDate: string
  calendarEvents: CalendarEvent[]
  numberOfUndisplayedEvents: number
}

const ShowMorePopup = ({
  formattedDate,
  calendarEvents,
  numberOfUndisplayedEvents,
}: ShowMorePopupProps) => {
  const { t } = useTranslation()

  const [popupOpen, setPopupOpen] = useState(false)

  return (
    <div>
      <Popup
        on="click"
        onClose={e => {
          const classList = (e?.target as Element)?.classList ?? []

          if (
            classList.contains('status-dropdown-button') ||
            classList.contains('status-option-button')
          ) {
            return
          }

          setTimeout(() => setPopupOpen(false), 250)
        }}
        open={popupOpen}
        position="top center"
        trigger={
          <MoreButton
            onClick={e => {
              e.stopPropagation()
              setPopupOpen(true)
            }}>
            {t('+{{number}} more', {
              number: numberOfUndisplayedEvents,
            })}
          </MoreButton>
        }
        content={
          <MoreWrapper onClick={e => e.stopPropagation()}>
            <div>
              {(calendarEvents || []).map(event => {
                const startedBefore = event.formattedStartDate < formattedDate
                const endsAfter = event.formattedEndDate > formattedDate

                let classes = `${
                  startedBefore ? 'pointy-start' : 'vacation-period-start'
                } ${endsAfter ? 'pointy-end' : 'vacation-period-end'}`

                if (!event.allDay) {
                  classes = `${classes} not-all-day`
                }

                if (!event.hasBeenApproved) {
                  classes = `${classes} unapproved`
                }

                return (
                  <Popup
                    inverted
                    key={event.id}
                    content={event.popupContent}
                    on="click"
                    position="top center"
                    flowing
                    disabled={!event}
                    trigger={
                      <CalendarEntry
                        onClick={e => e.stopPropagation()}
                        color={event.color}
                        className={classes}>
                        <span className="vacation-name" title={event.title}>
                          {event.label}
                        </span>
                      </CalendarEntry>
                    }
                  />
                )
              })}
            </div>
          </MoreWrapper>
        }
      />
    </div>
  )
}

export default ShowMorePopup
